const BUGSNAG_CONSTANTS = {
  SEVERITY: {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
  },
};

export default BUGSNAG_CONSTANTS;
